export default "__VITE_ASSET__BP2I32nO__"